import { apiURL } from "../utils/constants"
import { message } from "antd"
import { Fonts } from "../utils/constants";
import { DataResponse, DataState } from '../interfaces/commonInterfaces';
export function postCanal(data: any, dataCotizador :DataState): any {
     if(dataCotizador.quoteType === 0)  {
        return new Promise((resolve, reject) => {
            fetch(apiURL + `/ekatenachannel`,
                {
                    method: "POST",
                    body: data,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => response.json())
                .then(response => resolve(response))
                .catch(error => {
                    message.error({ content: 'Ocurrió un error al guardar los datos de simulación', style: { fontFamily: Fonts.sspRegular } });
                    reject(error);
                })
        })
    }
    else if (dataCotizador.quoteType === 1)  {
        return new Promise((resolve, reject) => {
            fetch(apiURL + `/CotizacionCredito`,
                {
                    method: "POST",
                    body: data,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                .then(response => response.json())
                .then(response => resolve(response))
                .catch(error => {
                    message.error({ content: 'Ocurrió un error al guardar los datos de simulación', style: { fontFamily: Fonts.sspRegular } });
                    reject(error);
                })
        })
        }
}
export async function postMethodContactChange(
  preauthId: number,
  methodContact: number,
) {
  const response = await fetch(apiURL + `/MethodContactChange`, {
    method: "POST",
    body: JSON.stringify({
      preauthId,
      methodContact,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Error al actualizar método de contacto");
  }

  return true;
}
